import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { getBankAccountSuccess, getBankAccountFailure } from '../actions';
import internationalPaymentConfigTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* getBankAccount() {
  const url = `${API_BASE_URL}/stripe`;
  const response = yield request({
    method: 'get',
    url,
  });

  if (response.success) {
    yield put(getBankAccountSuccess(response?.raw));
  } else {
    yield put(getBankAccountFailure('An error occured. Please reload the page to try again.'));
    networkErrorHandler(response?.statusCode, response?.message?.string || response?.message);
  }
}

export function* onGetBankAccount() {
  yield takeLatest(
    internationalPaymentConfigTypes.GET_BANK_ACCOUNT_REQUEST,
    getBankAccount
  );
}
